import ChartCardBackgroundImage from 'assets/images/chart-background.png'
import styled from 'styled-components'
import { SPACING, COLORS } from 'utils'

export const InfoCardContainer = styled.div`
  background-image: url(${ChartCardBackgroundImage});
  background-position: center;
  border-radius: 2px;
  height: 130px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
`

export const InfoCardHeader = styled.div`
  background-color: ${COLORS.tableColor};
  padding: ${SPACING.spacing20};
  border-top-left-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: 2px;
`

export const HeaderTitle = styled.span`
  color: ${COLORS.blueFonts};
  font-size: 0.9rem;
  text-align: center;
  font-family: arial;
  font-weight: bold;
`

export const ContentTitle = styled.h2`
  font-weight: bold;
  font-family: arial;
  text-align: center;
`
